export default "__VITE_ASSET__58c59571__"